import { render, staticRenderFns } from "./CategoryConfigFields.vue?vue&type=template&id=3557d6a4&"
import script from "./CategoryConfigFields.vue?vue&type=script&lang=js&"
export * from "./CategoryConfigFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports